/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_SubtitleInputs */

const en_home_cta_subtitle = /** @type {(inputs: Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No download and no account needed to start. Start drafting with nothing to install.`)
};

/**
* | output |
* | --- |
* | "No download and no account needed to start. Start drafting with nothing to install." |
*
* @param {Home_Cta_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_cta_subtitle = /** @type {((inputs?: Home_Cta_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_cta_subtitle(inputs)
});
export { home_cta_subtitle as "home.cta.subtitle" }